import {dom, library} from "@fortawesome/fontawesome-svg-core";
import * as SolidIcons from "@fortawesome/free-solid-svg-icons";

export default function () {
    library.add(SolidIcons.faEdit);
    library.add(SolidIcons.faMinus);
    library.add(SolidIcons.faPlus);
    library.add(SolidIcons.faPrint);
    library.add(SolidIcons.faTrash);
    dom.watch();
}
